module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _h('section', {
    attrs: {
      "id": "about"
    }
  }, [_h('div', {
    staticClass: "bio-container"
  }, [_h('div', {
    staticClass: "headshot"
  }, [_h('img', {
    attrs: {
      "src": require("../assets/headshot.png")
    }
  }), " ", (false) ? _h('div', {
    staticClass: "atvImg"
  }, [_h('img', {
    attrs: {
      "src": require("../assets/headshot.png")
    }
  }), " ", _h('div', {
    staticClass: "atvImg-layer",
    attrs: {
      "data-img": _vm.getHeadshotLayer(3)
    }
  }), " ", _h('div', {
    staticClass: "atvImg-layer",
    attrs: {
      "data-img": _vm.getHeadshotLayer(2)
    }
  }), " ", _h('div', {
    staticClass: "atvImg-layer",
    attrs: {
      "data-img": _vm.getHeadshotLayer(1)
    }
  })]) : _vm._e()]), " ", _vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
  return _h('div', {
    staticClass: "bio"
  }, [_h('h3', ["Beginnings"]), " ", _h('p', ["\n        Despite how uncommon personal computers were when I was a child, I was fascinated\n        by the idea of using them to create programs that do things. As I grew up I always\n        had the dream of creating things on computers, though I never actually had a computer\n        until I was 18 years old. Once I did, though, I spent my days and nights teaching\n        myself to bring my dream to life, eventually graduating Cum Laude with a B.S. in\n        Computer Science and turning my passion into my career.\n      "]), " ", _h('h3', ["Expertise"]), " ", _h('p', ["\n        I have spent most of my professional career doing what has always been the most fulfilling:\n        designing and implementing from scratch large-scale Web software systems, historically\n        built and maintained entirely myself on a stack including Ubuntu, MySQL, PHP, Nginx, and jQuery.\n      "]), " ", _h('p', ["\n        In the past few years with the massive paradigm shift in front-end development, I have\n        been falling in love all over again, and because of that love, I have been essentially living\n        on the front-end.\n      "]), " ", _h('h3', ["Personal Homepage"]), " ", _h('p', ["\n        I wrote this personal homepage you're currently reading in its entirety with VueJS 2\n        and bundled with Webpack. The source code is available in this GitHub repository:\n\n        ", _h('ul', [_h('li', [_h('a', {
    attrs: {
      "href": "https://github.com/rommelsantor/personal-homepage",
      "target": "_blank"
    }
  }, ["Personal Homepage"])])])]), " ", _h('h3', ["On the Web"]), " ", _h('p', ["\n        You can find more about me scattered around the Web, but here are a few locations where\n        I have been spending time recently.\n\n        ", _h('ul', [_h('li', [_h('a', {
    attrs: {
      "href": "http://linkedin.com/in/rommelsantor",
      "target": "_blank"
    }
  }, ["LinkedIn"])]), " ", _h('li', [_h('a', {
    attrs: {
      "href": "http://github.com/rommelsantor",
      "target": "_blank"
    }
  }, ["GitHub"])]), " ", _h('li', [_h('a', {
    attrs: {
      "href": "http://codepen.io/rommelsantor",
      "target": "_blank"
    }
  }, ["CodePen"])]), " ", _h('li', [_h('a', {
    attrs: {
      "href": "http://stackoverflow.com/users/2316774/rommel-santor",
      "target": "_blank"
    }
  }, ["StackOverflow"])])])]), " ", _h('p', ["\n        Here are some other code resources that may be of interest, but that are more likely\n        to have a bit of dust on them.\n\n        ", _h('ul', [_h('li', [_h('a', {
    attrs: {
      "href": "/clog",
      "target": "_blank"
    }
  }, ["My Coding Blog"])]), " ", _h('li', [_h('a', {
    attrs: {
      "href": "/jquery",
      "target": "_blank"
    }
  }, ["My jQuery Plugins"])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2d0cd7c4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/About.vue
// module id = 50
// module chunks = 1